/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { DateInputRow } from '../../../../javascript/shared/components/form';
import { getPlatformTimeZoneName } from '../../../../javascript/shared/utils/platform-timezone';
import { FormHeader } from './form_header.jsx';
import { FormThemeContext } from './form_theme_context.js.jsx';
import { FormInputGroup } from './form_input_group.jsx';
import { Checkbox } from './checkbox.jsx';
import { DateInputFloatingRow } from './date_input_floating_row.jsx';
import { FormRow } from './form_row.jsx';
import React from 'react';
import moment from 'moment';
import _ from 'underscore';
import { InstanceList } from './instance_list_component.jsx';
import classNames from 'classnames';

// Return a number's ordinal form
const asOrdinal = function(number) {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = number % 100;
  const suffix = suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];

  return `${number}${suffix}`;
};

// Spell out small (<= 10) positive integers, otherwise just return hte number
const numberAsWord = function(number) {
  const numbers = [null, 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
  if ((number > 0) && (number <= 10)) {
    return numbers[number];
  }
    return number;

};

// Pluralize the given string for count
const pluralize = function(count, string, plural_string = null) {
  if (Number(count) === 1) {
    return string;
  }
    return plural_string || (`${string  }s`);

};

// Component wrapping a form segment for the instance management
//
// This covers the date inputs as well as the instance list
export class InstanceManagerComponent extends React.Component {
  static contextType = FormThemeContext;

  static defaultProps = {
    formHasDateError: false,
    componentTitle: "Schedule",
    confirmedDatesHeader: "Confirmed Dates",
    requiredAsAsterisk: false,
    showReservationStatusColumn: false,
    readOnly: false
  };

        constructor(props) {
          super(props);
          this.componentDidMount = this.componentDidMount.bind(this);
          this.componentWillUnmount = this.componentWillUnmount.bind(this);
          this._instancesChanged = this._instancesChanged.bind(this);
          this._resetInputFields = this._resetInputFields.bind(this);
          this._inputChanged = this._inputChanged.bind(this);
          this.addInstances = this.addInstances.bind(this);
          this.setFieldState = this.setFieldState.bind(this);
          this.validateState = this.validateState.bind(this);
          this.getRecurranceSummary = this.getRecurranceSummary.bind(this);
this.getRecurrenceSettings = this.getRecurrenceSettings.bind(this);

          // Create initial state
          this.state = {
            // Repeat type
            repeat_type: 'once',
            // Repeat interval
            interval: 1,
            // Selected days of week (weekly recurrence)
            weekdays: [0, 1, 2, 3, 4, 5, 6],
            // Month repeat type (monthly recurrence)
            month_repeat_on: 'day_of_month',
            // End type for recurrence
            recurrence_end_type: 'date',
            // End date for recurrence
            recurrence_end_date: null,
            recurrence_end_date_invalid: false,
            // End count for recurrence
            recurrence_end_count: null,
            recurrence_end_count_invalid: false,
            // Current entry start date
            start_date: null,
            start_date_invalid: false,
            // Current entry start time
            start_time: null,
            start_time_invalid: false,
            // Current entry end time
            end_time: null,
            end_time_invalid: false,
            // Remove future instances
            remove_future_instances: false,
            // Valid values entered, allowing addition of dates
            valid_entry: false,
            // Have entries of dates
            have_dates: this.props.eventInstances.count() > 0
          };

          this.state.time_zone_name = getPlatformTimeZoneName();

          // Update field values based on the initial stuff
          this.state = Object.assign({}, this.state, this.props.eventInstances.getInputFields());
        }

        componentDidMount() {
          this.props.eventInstances.on('slzr:instance:add', this._instancesChanged);
          this.props.eventInstances.on('slzr:instance:change', this._instancesChanged);
          this.props.eventInstances.on('slzr:instance:remove', this._instancesChanged);
          return this.props.eventInstances.on('slzr:fields:changed', this._resetInputFields);
        }

        componentWillUnmount() {
          this.props.eventInstances.removeListener('slzr:instance:add', this._instancesChanged);
          this.props.eventInstances.removeListener('slzr:instance:change', this._instancesChanged);
          this.props.eventInstances.removeListener('slzr:instance:remove', this._instancesChanged);
          return this.props.eventInstances.removeListener('slzr:fields:changed', this._resetInputFields);
        }

        _instancesChanged(instances) {
          return this.setState({have_dates: this.props.eventInstances.count() > 0});
        }

        _resetInputFields() {
          return this.setState(this.props.eventInstances.getInputFields());
        }

        // Handler for input changes
        _inputChanged(event, value) {
          switch (event.target.name) {
            case 'start_date':
              if ((value === 'error') || (value === 'blank')) {
                this.setFieldState({start_date_invalid: true, start_date: null, start_date_input: event.target.value}, this.validateState);
              } else {
                this.setFieldState({start_date_invalid: false, start_date: value, start_date_input: event.target.value}, this.validateState);
              }
              break;

            case 'start_time':
              if (value === 'error') {
                this.setFieldState({start_time_invalid: true, start_time: null, start_time_input: event.target.value}, this.validateState);
              } else if (value === 'blank') {
                this.setFieldState({start_time_invalid: false, start_time: null, start_time_input: event.target.value}, this.validateState);
              } else {
                this.setFieldState({start_time_invalid: false, start_time: value, start_time_input: event.target.value}, this.validateState);
              }
              break;

            case 'end_time':
              if (value === 'error') {
                this.setFieldState({end_time_invalid: true, end_time: null, end_time_input: event.target.value}, this.validateState);
              } else if (value === 'blank') {
                this.setFieldState({end_time_invalid: false, end_time: null, end_time_input: event.target.value}, this.validateState);
              } else {
                this.setFieldState({end_time_invalid: false, end_time: value, end_time_input: event.target.value}, this.validateState);
              }
              break;

            case 'repeats':
              this.setFieldState({repeat_type: event.target.value}, this.validateState);
              break;

            case 'interval':
              this.setFieldState({interval: event.target.value}, this.validateState);
              break;

            case 'new_instance_recurrence_day':
              var new_weekdays = this.state.weekdays.splice(0);
              var weekday = Number(event.target.value);

              if (value) {
                // Chosen
                if (!(new_weekdays.indexOf(weekday) > -1)) { new_weekdays.push(weekday); }
              } else {
                // Removed
                const index = new_weekdays.indexOf(weekday);
                if (index > -1) {
                  new_weekdays.splice(index, 1);
                }
              }

              this.setFieldState({weekdays: new_weekdays.sort()}, this.validateState);
              break;

            case 'month_repeat_on':
              this.setFieldState({month_repeat_on: event.target.value}, this.validateState);
              break;

            case 'recurrence_end_type':
              this.setFieldState({recurrence_end_type: event.target.value}, this.validateState);
              break;

            case 'recurrence_end_date':
              if (value === 'error') {
                this.setFieldState({recurrence_end_date_invalid: true, recurrence_end_date: null, recurrence_end_date_input: event.target.value}, this.validateState);
              } else if (value === 'blank') {
                this.setFieldState({recurrence_end_date_invalid: true, recurrence_end_date: null, recurrence_end_date_input: event.target.value}, this.validateState);
              } else {
                this.setFieldState({recurrence_end_date_invalid: false, recurrence_end_date: value, recurrence_end_date_input: event.target.value}, this.validateState);
              }
              break;

            case 'recurrence_end_count':
              if (Number(event.target.value) > 0) {
                this.setFieldState({recurrence_end_count: event.target.value, recurrence_end_count_invalid: false}, this.validateState);
              } else {
                this.setFieldState({recurrence_end_count: event.target.value, recurrence_end_count_invalid: true}, this.validateState);
              }
              break;

            case 'new_instance_remove_future_dates':
              this.setFieldState({remove_future_instances: value}, this.validateState);
              break;
          }

          if (typeof this.props.onInputChange === 'function') {
            this.props.onInputChange(event);
          }
          return event.stopPropagation();
        }

        // Handler for clicking of add button, this commits the changes to the instance list
        addInstances(event) {
          const settings = this.getRecurrenceSettings();
          this.props.eventInstances.addRecurring(settings);
          return (typeof this.props.onInstancesAdded === 'function' ? this.props.onInstancesAdded(event) : undefined);
        }

        // Wrap setState to additionaly sync the changes to the EventInstances object
        setFieldState(changes, callback) {
          // Set the form state in EventInstances without triggering an update event
          this.props.eventInstances.setInputFields(changes, true);
          // And update react
          return this.setState(changes, callback);
        }

        // Validate the state and set the global validation flag appropriately
        validateState() {
          // Form validation checks
          const start_date_invalid = this.state.start_date_invalid || !this.state.start_date;
          const recurrence_end_count_invalid = this.state.recurrence_end_count_invalid || !this.state.recurrence_end_count;
          const recurrence_end_date_invalid = this.state.recurrence_end_date_invalid || !this.state.recurrence_end_date;

          const valid_start_date = !this.state.start_date_invalid && this.state.start_date;
          const valid_start_time = !this.state.start_time_invalid;
          const valid_end_time = !this.state.end_time_invalid;
          const valid_recurrence_end = (this.state.repeat_type === 'once') ||
            ((this.state.recurrence_end_type === 'date') && !this.state.recurrence_end_date_invalid && this.state.recurrence_end_date) ||
            ((this.state.recurrence_end_type === 'count') && !this.state.recurrence_end_count_invalid && this.state.recurrence_end_count);

          const valid_entry = valid_start_date && valid_start_time && valid_end_time && valid_recurrence_end;

          this.props.eventInstances.setInputFields({valid_entry}, true);

          // Notify the adapter when a valid start date is entered so it
          // can clear the date error without waiting for the next submit.
          if (valid_start_date && this.props.formHasDateError) {
            if (typeof this.props.onDateBecameValid === 'function') {
              this.props.onDateBecameValid();
            }
          }

          return this.setState({
            valid_entry,
            start_date_invalid
          });
        }


        render() {
          let day_of_month_text; let day_of_week_text;
          let day; let lbl;
          const my = this;

          // Generate some of the option selections for large, programmtic lists

          // ...count list
          const interval_unit = (() => { switch (this.state.repeat_type) {
            case 'daily':
              return 'day';
            case 'weekdays': case 'weekdays_mwf': case 'weekdays_tth': case 'weekly':
              return 'week';
            case 'monthly_day_of_week': case 'monthly_day_of_month':
              return 'month';
            case 'yearly':
              return 'year';
            default:
              return '';
          } })();

          const interval_options = (__range__(1, 30, true).map((i) => <option key={i} value={i}>{i} {interval_unit}{i != 1 ? 's' : ''}</option>));

          // ...weekday option checkboxes
          const weekday_options = ((() => {
            const result = [];
            for ([day, lbl] of ([
            [0, 'Sun'],
            [1, 'Mon'],
            [2, 'Tue'],
            [3, 'Wed'],
            [4, 'Thu'],
            [5, 'Fri'],
            [6, 'Sat']
          ])) {               result.push(<td key={day}>
                                    <span className="day">{lbl}</span>
                                    <Checkbox value={day}
                                              checked={my.state.weekdays.indexOf(day) > -1}
                                              className="recur_day"
                                              data-instance="recurrence-day"
                                              onChange={my._inputChanged}
                                              name="new_instance_recurrence_day" />
                                  </td>);
            }
            return result;
          })());


          const weekday_options_list = ((() => {
            const result1 = [];
            for ([day, lbl] of ([
            [0, 'Sun'],
            [1, 'Mon'],
            [2, 'Tue'],
            [3, 'Wed'],
            [4, 'Thu'],
            [5, 'Fri'],
            [6, 'Sat']
          ])) {               result1.push(<label key={day} className="em-checkbox">

                                    <Checkbox value={day}
                                              checked={my.state.weekdays.indexOf(day) > -1}
                                              className="recur_day"
                                              data-instance="recurrence-day"
                                              onChange={my._inputChanged}
                                              name="new_instance_recurrence_day" />
                                    <span className="day">{lbl}</span>
                                  </label>);
            }
            return result1;
          })());

          // Calculate visibility options
          const is_recurring = this.state.repeat_type !== 'once';
          const summary_text = this.getRecurranceSummary();

          // Active date text
          const start = this.state.start_date ? moment(this.state.start_date) : moment();

          if (start.date() === start.daysInMonth()) {
            day_of_month_text = 'last';
          } else {
            day_of_month_text = start.format('Do');
          }

          const week_number = start.monthWeekByDay();
          if (week_number === 4) {
            day_of_week_text = `last ${start.format('dddd')}`;
          } else {
            day_of_week_text = `${['first', 'second', 'third', 'fourth'][week_number]  } ${  start.format('dddd')}`;
          }

          // Main UI
          if (this.props.isRenderedInAdmin) {
            const instanceListClassNames = classNames(
              'form-event-date',
              {
                'instance-list--with-reservation-status': this.props.showReservationStatusColumn
              }
            );

              return <div>
                {!this.props.readOnly && <FormInputGroup>
                  <legend className="sr-only">{this.props.componentTitle}</legend>
                  <div className="form_column-2">
                  <DateInputRow label="Start Date"
                                name="start_date"
                                placeholder="'Tomorrow' or 'Next Friday' or '4/10'"
                                initialValue={this.state.start_date}
                                initialInputValue={this.state.start_date_input}
                                onChange={this._inputChanged}
                                showPreview={false}
                                showError={!!this.props.startDateError}
                                errorMessage={this.props.startDateError}
                                required={true}
                                requiredAsAsterisk={this.props.requiredAsAsterisk}
                                {...this.context.textInputRow} {...this.context.error} />
                  <DateInputRow label="Start Time"
                                name="start_time"
                                placeholder="6pm"
                                initialValue={this.state.start_time}
                                initialInputValue={this.state.start_time_input}
                                onChange={this._inputChanged}
                                showPreview={false}
                                showError={false}
                                type="time"
                                {...this.context.textInputRow} />
                  <DateInputRow label="End Time"
                                name="end_time"
                                initialValue={this.state.end_time}
                                initialInputValue={this.state.end_time_input}
                                onChange={this._inputChanged}
                                showPreview={false}
                                showError={false}
                                type="time"
                                {...this.context.textInputRow} />

                  <FormRow title="Repeating"
                           labelFor="repeats"
                           {...this.context.selectInputRow}>
                    <select ref="repeats"
                            className="admin-common-dropdown"
                            id="repeats"
                            value={this.state.repeat_type}
                            onChange={this._inputChanged}
                            name="repeats" >
                      <option value="once">Never</option>
                      <option value="daily">Every day</option>
                      <option value="weekdays">Every weekday</option>
                      <option value="weekdays_mwf">Every Mon, Wed, Fri</option>
                      <option value="weekdays_tth">Every Tue, Thu</option>
                      <option value="weekly">Every week</option>
                      <option value="monthly_day_of_month">The {day_of_month_text} day</option>
                      <option value="monthly_day_of_week">The {day_of_week_text}</option>
                      <option value="yearly">Every year</option>
                    </select>
                  </FormRow>

                  {['daily', 'weekly', 'monthly_day_of_month', 'monthly_day_of_week', 'yearly'].indexOf(this.state.repeat_type) > -1 &&
                    <FormRow title="Every"
                             labelFor="interval"
                             {...this.context.selectInputRow}>
                      <select ref="interval"
                              id="interval"
                              className="admin-common-dropdown"
                              value={this.state.interval}
                              onChange={this._inputChanged}
                              name="interval">
                        {interval_options}
                      </select>
                    </FormRow>}

                  {this.state.repeat_type == 'weekly' && <FormRow title="Repeat on"
                                                                  {...this.context.selectInputRow}
                           className="week_table_wrapper"
                           data-instance="recurrence-day-wrapper">
                    <div className="week_table">
                      <table border="0">
                        <tbody>
                          <tr>
                            {weekday_options}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </FormRow>}

                  {/*
                    should use this css to align properly

                   .form-horizontal.nosides label.end-date-range > .end-date-range-input {
                       width: 35%;
                       float: none;
                   }
                    */}
                  {is_recurring && <FormRow title="Repeating until"
                                            labelFor="recurrence_end_type"
                                            {...this.context.selectInputRow}
                                            className="end-date-range">
                    <select className="admin-common-dropdown end-date-range-input"
                            id="recurrence_end_type"
                            name="recurrence_end_type"
                            value={this.state.recurrence_end_type}
                            onChange={this._inputChanged}>
                      <option value="date">A specific date has passed</option>
                      <option value="count">A number of times have passed</option>
                    </select>
                  </FormRow>}

                  {is_recurring && this.state.recurrence_end_type == 'date' &&
                    <DateInputRow label={this.context.labelAllInputs ? "Repeat until this date" : ""}
                                  name="recurrence_end_date"
                                  onChange={this._inputChanged}
                                  placeholder="tomorrow"
                                  initialValue={this.state.recurrence_end_date}
                                  initialInputValue={this.state.recurrence_end_date_input}
                                  showPreview={false}
                                  showError={false}
                                  type="date"
                                  {...this.context.textInputRow} />}

                  {is_recurring && this.state.recurrence_end_type == 'count' &&
                    <FormRow title={this.context.labelAllInputs ? "Repeat this number of times" : ""}
                             labelFor="recurrence_end_count"
                             {...this.context.textInputRow}>
                      <input type="text"
                             id="recurrence_end_count"
                             name="recurrence_end_count"
                             className={this.context.textInputRow.inputClassName}
                             value={this.state.recurrence_end_count}
                             onChange={this._inputChanged}
                             placeholder="12" />
                    </FormRow>}

                  {summary_text && <FormRow title="Summary">
                    <div className="schedule-summary">{summary_text}</div>
                  </FormRow>}

                  {/* WP_CHANGE: i18n definitions comes from en.yml:463 */}
                  {is_recurring && <FormRow title="Overwrite scheduled dates"
                                            labelFor="new_instance_remove_future_dates"
                                            {...this.context.checkboxRow}>
                    <Checkbox name="new_instance_remove_future_dates"
                              id="new_instance_remove_future_dates"
                              type="checkbox"
                              value="1"
                              className="admin-common-checkbox checkbox_input"
                              onChange={this._inputChanged}
                              data-instance="remove-future-dates"/>
                  </FormRow>}

                  {/* WP_CHANGE: i18n definitions comes from en.yml:459-461 */}
                  <div className="action-button pull-right">
                    <input type="button"
                           className="btn-color"
                           name="add_instance"
                           disabled={!this.state.valid_entry}
                           onClick={this.addInstances}
                           value={is_recurring && this.state.remove_future_instances ? 'Replace Existing Schedule' :
                             this.state.have_dates ? "Include Above in Schedule" : "Add Above to Schedule"}
                           data-action="add-instance"
                           data-ganame="add_recurring_submit"
                           id="x-add-instance" />

                  </div>
                  </div>
                </FormInputGroup>}

                {this.state.have_dates && <FormInputGroup>
                  <FormHeader title={this.props.confirmedDatesHeader} className="sub-heading" />
                </FormInputGroup>}

                {this.state.have_dates && <FormInputGroup className={instanceListClassNames}>
                  <legend className='sr-only'>{this.props.confirmedDatesHeader}</legend>
                  <InstanceList
                    eventInstances={this.props.eventInstances}
                    isRenderedInAdmin={this.props.isRenderedInAdmin}
                    showReservationStatusColumn={this.props.showReservationStatusColumn}
                    readOnly={this.props.readOnly}
                    timeZoneName={this.state.time_zone_name} />
                </FormInputGroup>}
              </div>;
          }
             return <div>
                {!this.props.readOnly && <FormInputGroup>
                  <legend className="sr-only">{this.props.componentTitle}</legend>
                  <div className="em-form_column-2 em-align-start">
                  <DateInputFloatingRow label="Start Date"
                                name="start_date"
                                placeholder="'Tomorrow' or 'Next Friday' or '4/10'"
                                onChange={this._inputChanged}
                                icon=""
                                formHasDateError={this.props.formHasDateError}
                                required={true}
                                dateError="Invalid start date."/>
                  <DateInputFloatingRow label="Start Time"
                                name="start_time"
                                placeholder="6pm"
                                onChange={this._inputChanged}
                                showPreview={false}
                                showError={false}
                                type="time" />
                  <DateInputFloatingRow label="End Time"
                                name="end_time"
                                onChange={this._inputChanged}
                                showPreview={false}
                                showError={false}
                                type="time" />


                    <div className="em-select-floating">
                      <label htmlFor="repeats">Repeating</label>
                      <select ref="repeats"
                              value={this.state.repeat_type}
                              onChange={this._inputChanged}
                              name="repeats"
                              id="repeats">
                        <option value="once">Never</option>
                        <option value="daily">Every day</option>
                        <option value="weekdays">Every weekday</option>
                        <option value="weekdays_mwf">Every Mon, Wed, Fri</option>
                        <option value="weekdays_tth">Every Tue, Thu</option>
                        <option value="weekly">Every week</option>
                        <option value="monthly_day_of_month">The {day_of_month_text} day</option>
                        <option value="monthly_day_of_week">The {day_of_week_text}</option>
                        <option value="yearly">Every year</option>
                      </select>
                      <i className="fas fa-sort-down"></i>
                    </div>


                  {['daily', 'weekly', 'monthly_day_of_month', 'monthly_day_of_week', 'yearly'].indexOf(this.state.repeat_type) > -1 &&

                    <div className="em-select-floating">
                      <label htmlFor="interval">Every</label>
                      <select ref="interval"
                              value={this.state.interval}
                              onChange={this._inputChanged}
                              id="interval"
                              name="interval">
                        {interval_options}
                      </select>
                      <i className="fas fa-sort-down"></i>
                    </div>
                    }

                  {this.state.repeat_type == 'weekly' && <div
                           className="week_table_wrapper"
                           data-instance="recurrence-day-wrapper">
                           <span className="em-input_label">Repeat on</span>
                    <div className="em-week_table week_table">

                            {weekday_options_list}

                    </div>
                  </div>}

                  {/*
                    should use this css to align properly

                   .form-horizontal.nosides label.end-date-range > .end-date-range-input {
                       width: 35%;
                       float: none;
                   }
                    */}
                  {is_recurring && <div className="end-date-range">
                      <div className="em-select-floating">
                        <label id="recurrence_end_type_label" htmlFor="recurrence_end_type">Repeating until</label>
                        <select className="end-date-range-input"
                                name="recurrence_end_type"
                                id="recurrence_end_type"
                                value={this.state.recurrence_end_type}
                                onChange={this._inputChanged}>
                          <option value="date">A specific date has passed</option>
                          <option value="count">A number of times have passed</option>
                        </select>
                        <i className="fas fa-sort-down"></i>
                      </div>
                  </div>}

                  {is_recurring && this.state.recurrence_end_type == 'date' &&
                    <DateInputFloatingRow label="A specific date has passed"
                                  name="recurrence_end_date"
                                  onChange={this._inputChanged}
                                  placeholder="A specific date has passed"
                                  initialValue={this.state.recurrence_end_date}
                                  showPreview={false}
                                  showError={false}
                                  type="date"/>}

                  {is_recurring && this.state.recurrence_end_type == 'count' &&
                    <div className="em-input-floating">
                      <input type="text"
                             name="recurrence_end_count"
                             value={this.state.recurrence_end_count}
                             onChange={this._inputChanged}
                             placeholder="Number of times have passed" />
                      <label>Number of times have passed</label>
                    </div>}
                </div>

                  {summary_text && <p className="edit_event_summary">
                    <span role="heading" aria-level="3">Summary</span>
                    <div className="schedule-summary">{summary_text}</div>
                  </p>}
                  <div className="em-form_column-2">
                  {/* WP_CHANGE: i18n definitions comes from en.yml:463 */}
                  {is_recurring && <label className="em-checkbox">
                    <Checkbox name="new_instance_remove_future_dates"
                              id="new_instance_remove_future_dates"
                              type="checkbox"
                              value="1"
                              className="checkbox_input"
                              onChange={this._inputChanged}
                              data-instance="remove-future-dates"/>
                  <span>Overwrite scheduled dates</span>
                  </label>}
                  {/* WP_CHANGE: i18n definitions comes from en.yml:459-461 */}
                  <div className="action-button pull-right">
                    <input type="button"
                           className="btn-color em-button em-primary"
                           name="add_instance"
                           disabled={!this.state.valid_entry}
                           onClick={this.addInstances}
                           value={is_recurring && this.state.remove_future_instances ? "Replace Existing Schedule" :
                             this.state.have_dates ? "Above in Schedule" : "Add Above to Schedule"}
                           data-action="add-instance"
                           data-ganame="add_recurring_submit"
                           id="x-add-instance" />

                  </div>
                  </div>
                </FormInputGroup>}

                {this.state.have_dates && <FormInputGroup>
                  <span className="em-input_label">{this.props.confirmedDatesHeader}</span>
                </FormInputGroup>}

                {this.state.have_dates && <FormInputGroup className={`form-event-date${this.props.showReservationStatusColumn && this.props.isRenderedInAdmin ? ' instance-list--with-reservation-status' : ''}`}>
                  <legend className='sr-only'>{this.props.confirmedDatesHeader}</legend>
                  <InstanceList
                    eventInstances={this.props.eventInstances}
                    isRenderedInAdmin={this.props.isRenderedInAdmin}
                    showReservationStatusColumn={this.props.showReservationStatusColumn}
                    readOnly={this.props.readOnly}
                    timeZoneName={this.state.time_zone_name} />
                </FormInputGroup>}
              </div>;

        }

        // Generate summary text
        //
        // DAILY/WEEKLY: Every [DOW1, DOW2 | Weekday | Weekend | Day]
        // MONTHLY: Every Nth day | Every third DOW
        // YEARLY: Every X years
        //
        // ending with:
        //  ; X times
        //  ; until Date
        getRecurranceSummary() {
          let summary_text;
          const settings = this.getRecurrenceSettings();

          // Return error message if part of the form is invalid
          if (this.state.start_date_invalid) { return "Invalid Start Date"; }
          if (this.state.start_time_invalid) { return "Invalid Start Time"; }
          if (this.state.end_time_invalid) { return "Invalid End Time"; }

          // Show errors or hints for recurrence end
          if (this.state.repeat_type !== 'once') {
            // Recurrence end date
            if (this.state.recurrence_end_type === 'date') {
              if (this.state.recurrence_end_date_invalid) {
                return "Invalid Recurrence End Date";
              } else if (!this.state.recurrence_end_date) {
                return "Enter a recurrence end date above";
              }
            }

            // Recurrence end count
            if (this.state.recurrence_end_type === 'count') {
              if (this.state.recurrence_end_count_invalid) {
                return "Invalid Recurrence End Count";
              } else if (!this.state.recurrence_end_count) {
                return "Enter a recurrence end count above";
              }
            }
          }

          // Otherwise, build up the instance summary text
          let summary_text_date = [];
          if (settings.start_date) {
            if (settings.start_date) { summary_text_date.push(moment(settings.start_date).format('dddd, MMMM D, YYYY')); }
            if (settings.start_time) {
              if (settings.start_time) { summary_text_date.push(moment(settings.start_time).format(', h:mma')); }
              if (settings.end_time) {
                summary_text_date.push(' to ');
                summary_text_date.push(moment(settings.end_time).format('h:mma'));
              }
              if (this.state.time_zone_name) { summary_text_date.push(` ${  this.state.time_zone_name}`); }
            } else {
              summary_text_date.push(', all day');
            }
          }

          summary_text_date = summary_text_date.join('');

          if (this.state.repeat_type !== 'once') {
            let interval_label;
            const day_labels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

            summary_text = "repeating every ";
            if (settings.interval > 1) { summary_text += `${numberAsWord(settings.interval)  } `; }

            switch (settings.type) {
              case 'daily':
                interval_label = pluralize(settings.interval, 'day');
                break;
              case 'weekly':
                interval_label = pluralize(settings.interval, 'week');

                if (_.isEqual(settings.weekdays, [0, 1, 2, 3, 4, 5, 6])) {
                  interval_label += ' on all days';
                } else if (_.isEqual(settings.weekdays, [0, 6])) {
                  interval_label += ' on weekends';
                } else if (_.isEqual(settings.weekdays, [1, 2, 3, 4, 5])) {
                  interval_label += ' on weekdays';
                } else {
                  interval_label += ` on ${  (Array.from(settings.weekdays).map((day) => day_labels[day])).join(', ')}`;
                }
                break;
              case 'monthly':
                interval_label = pluralize(settings.interval, 'month');

                // Show the date it recurs on (either date or weekday)
                if (settings.start_date) {
                  const start_date = moment(settings.start_date);

                  if (settings.repeat_on === 'day_of_month') {
                    if (start_date.date() === start_date.daysInMonth()) {
                      interval_label += " on the last day";
                    } else {
                      interval_label += ` on the ${start_date.format('Do')}`;
                    }
                  } else if (settings.repeat_on === 'day_of_week') {
                    let week_number = start_date.monthWeekByDay();
                    if (week_number === 4) {
                      week_number = 'last';
                    } else {
                      week_number = ['first', 'second', 'third', 'fourth'][week_number];
                    }

                    interval_label += ` on the ${week_number} ${start_date.format('dddd')}`;
                  }
                }
                break;

              case 'yearly':
                interval_label = pluralize(settings.interval, 'year');
                break;
            }

            summary_text += interval_label;

            // Range end date
            if ((this.state.recurrence_end_type === 'date') && this.state.recurrence_end_date) {
              summary_text += " until ";
              summary_text += moment(this.state.recurrence_end_date).format('MMM D, YYYY');
            } else if ((this.state.recurrence_end_type === 'count') && (this.state.recurrence_end_count > 0)) {
              summary_text += `, ${  this.state.recurrence_end_count  } times`;
            }
          } else {
            summary_text = null;
          }

          let result = _.compact([summary_text_date, summary_text]).join(', ');

          // Hint if we aren't showing an error or a summary
          if (!result) { result = 'Enter a start date above'; }

          return result;
        }

        // Return the current recurrence settings based on the user's selections
        //
        // This normalizes the weekday dropdown choices with the selected weekdays
        getRecurrenceSettings() {
          return this.props.eventInstances.getRecurrenceSettings();
        }
}

function __range__(left, right, inclusive) {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
